import React from 'react';
import { OutlinedInput, OutlinedInputProps } from '@mui/material';
import { twMerge } from 'tailwind-merge';
import { FormItemName } from './FormItemName';

export interface TextareaProps extends Omit<OutlinedInputProps, 'multiline' | 'label'> {
  label?: string;
  required?: boolean;
  placeholder?: string;
  hasError?: boolean;
  containerClassName?: string;
  className?: string;
  minRows?: number;
  maxRows?: number;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      label,
      placeholder,
      required = false,
      containerClassName,
      className,
      hasError,
      minRows = 3,
      maxRows = 6,
      ...rest
    },
    ref,
  ) => {
    return (
      <div className={twMerge('', containerClassName)}>
        {label && <FormItemName name={label} isRequired={required} className="mb-[6px]" />}
        <OutlinedInput
          {...rest}
          inputRef={ref}
          className={twMerge(
            'block w-full bg-gray-50 p-4',
            'rounded-lg border border-gray-300',
            'font-manrope text-sm text-gray-900',
            'md:!bg-white md:!p-3 md:!text-base',
            'focus-within:border-[#25008a]/10 focus-within:border-opacity-10 focus-within:outline-none focus-within:ring-4 focus-within:ring-[#25008a]/10',
            className,
          )}
          sx={{
            '.MuiOutlinedInput-notchedOutline': {
              border: hasError ? '1px solid red' : 'none',
            },
            '.MuiInputBase-input': {
              border: 'none',
              boxShadow: 'none',
            },
          }}
          placeholder={placeholder}
          required={required}
          multiline
          minRows={minRows}
          maxRows={maxRows}
        />
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';
